var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "flex flex-col bg-white" }, [
    _vm.member.acf
      ? _c("img", {
          staticClass: "lazyload w-full object-cover",
          attrs: {
            src: _vm.member.acf.image.url,
            alt: _vm.member.acf.image.alt
          }
        })
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "p-[30px] bg-brown-400" }, [
      _vm.member.post_title
        ? _c(
            "h3",
            {
              staticClass: "text-22 tracking-normal text-orange font-semi mb-8"
            },
            [_vm._v(_vm._s(_vm.member.post_title))]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("p", { staticClass: "font-regular text-white text-18 mb-40" }, [
        _vm._v(_vm._s(_vm.member.acf.address))
      ]),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass:
            "text-white  text-18 font-regular hover:text-orange transition-colors",
          attrs: { href: "mailto:" + _vm.member.acf.email }
        },
        [
          _c("span", { staticClass: "text-orange mr-8" }, [_vm._v("E:")]),
          _vm._v(_vm._s(_vm.member.acf.email))
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }